module.exports = {"version":"0.18.4"}


//////////////////
// WEBPACK FOOTER
// ./~/ethpm-registry/~/web3/lib/version.json
// module id = 484
// module chunks = 0